import { Box, HStack, Header, Icon, Pressable, Text, VStack } from '@rbilabs/universal-components';
import { spacing } from '@rbilabs/universal-components/themes';

import loyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Link from 'components/link';
import { ProgressMeter } from 'components/progress-meter';
import { primitive } from 'styles/constants/primitives';

const CATEGORY_HEADER_HEIGHT = 44;
const METER_CONTAINER_WIDTH = '375px';
const EXPIRING_POINTS_MAX_WIDTH = 370;

export const CategoryLabel = Header.withConfig({
  fontSize: 'xl',
  margin: 0,
  flexGrow: 2,
});

export const ChallengeContainer = Box.withConfig(
  ({ addMargin = true }: { addMargin?: boolean }) => ({
    ...(addMargin && {
      margin: '$4',
    }),
  })
);

export const LoyaltyRewardsListContainer = Box.withConfig({
  marginTop: '$2',
});

export const LoyaltyRewardsListTitle = Header.withConfig({
  variant: 'headerOne',
});

export const RewardCategoryContainer = Pressable.withConfig<{
  locked: boolean;
}>(p => ({
  flexDir: 'column',
  paddingBottom: '$4',
  flex: 1,
  background: p.locked ? Styles.color.grey.nine : '',
}));

export const RewardCategoryHeader = VStack.withConfig({
  justifyContent: 'center',
  height: CATEGORY_HEADER_HEIGHT,
  paddingX: '$4',
  flexDir: 'row',
  alignItems: 'center',
  alignContent: 'space-between',
});

export const RewardCategoryCarouselContainer = Box.withConfig({
  flex: 1,
  flexDir: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  paddingX: '$4',
});

export const RewardCategoryMeterContainer = Box.withConfig({
  borderTopWidth: '1',
  borderTopColor: Styles.color.grey.four,
  backgroundColor: Styles.color.grey.nine,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '$4',
  paddingTop: '$8',
  paddingBottom: '$4',
});

export const MeterContainer = Box.withConfig({
  width: METER_CONTAINER_WIDTH,
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  paddingX: '$8',
});

export const StyledProgressMeter = ProgressMeter.withConfig({
  borderWidth: '0',
  background: primitive.$white,
});

export const PointsNeededContainer = HStack.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
});

export const PointsNeededText = Text.withConfig({
  fontSize: 'sm',
  fontWeight: 'bold',
  marginRight: '$1',
});

export const PointsNeededDescription = Text.withConfig({
  fontSize: 'xs',
});

export const StyledPointsIcon = loyaltyPointsIcon.withConfig({
  width: '$4',
  height: '$4',
  marginRight: '$1',
});

export const StyledRewardLock = Icon.withConfig({
  variant: 'locked',
  size: '$5',
});

export const PointsNeededLockIcon = StyledRewardLock.withConfig({
  size: '$5',
  color: primitive.bk.$bbqBrown,
});

export const CrownIcon = loyaltyPointsIcon.withConfig({
  width: '$7',
  height: '$7',
  marginRight: '$1',
});

export const RewardsTabLink = Link.withConfig<{ active?: boolean }>(p => ({
  flexGrow: 1,
  isUnderlined: false,
  margin: 0,
  textTransform: 'none',
  borderBottomWidth: 3,
  justifyContent: 'center',
  alignItems: 'center',
  borderBottomColor: p.active ? Styles.color.tertiary : 'transparent',
}));

export const RewardsTabLinkText = Header.withConfig<{ active?: boolean }>(p => ({
  color: p.active ? Styles.color.tertiary : Styles.color.tertiary,
  fontFamily: p.active ? Styles.fontFamily.base : Styles.fontFamily.body,
  fontSize: 'md',
  // margin vertical/Y not working consistently here
  marginTop: spacing.$1,
  marginBottom: spacing.$1,
}));

export const RewardsTabsBorderBottom = Box.withConfig({
  position: 'absolute',
  bottom: 0,
  width: 'full',
  height: '$0.5',
  backgroundColor: primitive.$blackOpacity10,
});

export const ExpiringPointsContainer = Box.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  marginX: '$2',
  marginBottom: '$2',
});

export const ExpiringPoints = Link.withConfig({
  height: '$13.5',
  maxWidth: {
    base: EXPIRING_POINTS_MAX_WIDTH,
    md: 'full',
  },
  marginTop: '$4',
  paddingX: {
    base: '$5',
    md: '$3',
  },
  backgroundColor: primitive.$white,
  borderRadius: 'lg',
  justifyContent: 'center',
  flexDirection: 'row',
  alignItems: 'center',
  _text: {
    textAlign: 'center',
  },
});

export const IconContainer = Box.withConfig({
  width: '$8',
  height: '$8',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '3xl',
  marginRight: '$3',
  flexShrink: 0,
  backgroundColor: primitive.bk.$meltyYellow,
});

export const ExpiringIcon = loyaltyPointsIcon.withConfig({
  size: 5,
  fill: primitive.$white,
});

export const PointsToExpireText = Text.withConfig({
  fontWeight: 'bold',
  marginX: '$1',
});
